import { NgModule } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { CompanyClient, CompanyModuleReferencesClient, LicenseClient, ModuleClient, UrlAddressClient } from './client-provider/client';

@NgModule({
  declarations: [],
  exports: [],
  providers: [
    DialogService,
    CompanyClient,
    LicenseClient,
    ModuleClient,
    CompanyModuleReferencesClient,
    UrlAddressClient
  ]
})
export class ClientModule { }
